import { RestApi } from '../../common/services';
import { store } from '../../common/store/store';
import { TSFixMe } from '../../frontend-libs/evlapp-types';

export interface IRepresentationFile {
  id: string;
  name: string;
  mime: string;
}

export interface IRepresentationRecord {
  id: string;
  representativeProfileId: string;
  representativeName: string;
  validTo: string | null;
  endedAt: string | null;
  endedReason: string | null;
  createdAt: string;
  files: IRepresentationFile[];
}

export interface IVotingProxyRecord extends IRepresentationRecord {
  representedProfileId: string;
}

interface IRepresentationIndex<T> {
  active: T | null;
  history: T[];
}

const buildingId = () => store.getState().security.ui.buildingId;

export type RepresentativeEmailCheckStatus = 'available' | 'owner' | 'member' | 'existing';

// POST kvůli e-mailu v těle požadavku — osobní údaj nepatří do URL
export const checkRepresentativeEmail = async (email: string): Promise<{ status: RepresentativeEmailCheckStatus }> => {
  return await RestApi.post<TSFixMe, { status: RepresentativeEmailCheckStatus }>(
    `/building/${buildingId()}/representative/check-email`,
    { email }
  );
};

export const getDesignatedVoter = async (unitId: string): Promise<IRepresentationIndex<IRepresentationRecord>> => {
  return await RestApi.get<never, IRepresentationIndex<IRepresentationRecord>>(
    `/building/${buildingId()}/unit/${unitId}/designated-voter`
  );
};

export const setDesignatedVoter = async (unitId: string, values: FormData): Promise<IRepresentationRecord> => {
  return await RestApi.post<FormData, IRepresentationRecord>(
    `/building/${buildingId()}/unit/${unitId}/designated-voter`,
    values,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
};

export const endDesignatedVoter = async (unitId: string): Promise<void> => {
  await RestApi.delete<never>(`/building/${buildingId()}/unit/${unitId}/designated-voter`);
};

export const getVotingProxy = async (profileId: string): Promise<IRepresentationIndex<IVotingProxyRecord>> => {
  return await RestApi.get<never, IRepresentationIndex<IVotingProxyRecord>>(
    `/building/${buildingId()}/profile/${profileId}/voting-proxy`
  );
};

export const createVotingProxy = async (profileId: string, values: FormData): Promise<IVotingProxyRecord> => {
  return await RestApi.post<FormData, IVotingProxyRecord>(
    `/building/${buildingId()}/profile/${profileId}/voting-proxy`,
    values,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
};

export const endVotingProxy = async (votingProxyId: string): Promise<void> => {
  await RestApi.delete<never>(`/building/${buildingId()}/voting-proxy/${votingProxyId}`);
};

/** Stažení dokumentu (plné moci) — autorizovaně přes axios, uloží jako soubor. */
export const downloadRepresentationFile = async (file: IRepresentationFile): Promise<void> => {
  const config: TSFixMe = {
    url: `/building/${buildingId()}/representation-file/${file.id}/download`,
    method: 'GET',
    responseType: 'blob',
  };

  await RestApi.axios(config).then((res: TSFixMe) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', file.name);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  });
};
